import { useEffect, useState } from 'react'
import { AxiosRequest } from "../axios"
import { useNavigate } from 'react-router-dom';

export const useProfile = () => {
    const navigate = useNavigate();
    const [state, setState] = useState({})
    const checkProfile = async (url) => {
        try {
            const response = await AxiosRequest({ url });
            if (response) {
                const { status, message } = response.data
                setState(status ? message[0] : {})
            } else {
                navigate('/login')
                sessionStorage.removeItem("token")
                setState({})
            }
        } catch (error) {
            console.error('Error checking secure route:', error);
            return setState({})
        }
    };
    useEffect(() => {
        checkProfile("/api/v1/role_profile");
    }, []);

    return { state };
};